import {BreakpointObserver} from "@angular/cdk/layout";
import {computed, inject, Injectable} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs";

export enum ScreenSize {
    SMALL = "SMALL",
    MEDIUM = "MEDIUM",
    LARGE = "LARGE"
}

const MEDIA_QUERY: Record<string, ScreenSize> = {
    "(max-width: 1399.98px)": ScreenSize.SMALL,
    "(min-width: 1400px) and (max-width: 1919.98px)": ScreenSize.MEDIUM,
    "(min-width: 1920px)": ScreenSize.LARGE,
};

@Injectable({providedIn: "root"})
export class LayoutService {
    public readonly screenSize = toSignal(inject(BreakpointObserver).observe(Object.keys(MEDIA_QUERY)).pipe(
        map(result => MEDIA_QUERY[Object.keys(MEDIA_QUERY).find((query) => result.breakpoints[query]) ?? ""]),
    ), {initialValue: ScreenSize.LARGE});

    public readonly isSmallScreen = computed(() => this.screenSize() === ScreenSize.SMALL);
    public readonly isMediumScreen = computed(() => this.screenSize() === ScreenSize.MEDIUM);
    public readonly isLargeScreen = computed(() => this.screenSize() === ScreenSize.LARGE);
}